import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SvgSuivi = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <Path
                fill={props.color ?? baseColors.green.primary}
                d="M0 10a2 2 0 114 0v10H0V10zm8-8a2 2 0 114 0v18H8V2zm8 5a2 2 0 114 0v13h-4V7z"
            />
        </Svg>
    )
}

export default SvgSuivi
